export const isDisablesSaveBtn = (selectedEmail, newEmail) =>
  selectedEmail !== undefined || newEmail.trim() !== ''

export const getPeriod = (possiblePeriods, period) => {
  if (period === undefined) {
    return ''
  }

  return possiblePeriods.find((e) => e.value === period).text
}
